define('ordersDetailOrderPhrasesPickerView',[
  'module',
  'marionette',
  'underscore',
  'jquery',
  'settings',
  'template!ordersDetailOrderPhrasesPickerView'
], function (
  Module,
  Marionette,
  _,
  $,
  Settings,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'phrase-picker-view',

    ui: {
      searchInput: '.picker-search-input',
      list: '.picker-list',
      confirmBtn: '.picker-confirm',
      cancelBtn: '.picker-cancel',
      selectionCount: '.picker-selection-count'
    },

    events: {
      'input @ui.searchInput': 'onSearch',
      'click .picker-item': 'onToggleItem',
      'click @ui.confirmBtn': 'onConfirm',
      'click @ui.cancelBtn': 'onCancel'
    },

    initialize: function (options) {
      this.phrases = options.phrases || [];
      this.selected = {};
      this.windows = options.windows || null;
      this.windows = options.windows;
    },

    onRender: function () {
      this._renderList(this.phrases);
    },

    _getDynamicTextValue: function (dt) {
      if (!dt || !dt.values) return '';
      var lang = Settings.get('lang') || 'en';
      if (dt.values[lang]) return dt.values[lang];
      var keys = Object.keys(dt.values);
      return keys.length > 0 ? dt.values[keys[0]] : '';
    },

    _renderList: function (phrases) {
      var self = this;
      var html = '';

      _.each(phrases, function (p) {
        var name = self._getDynamicTextValue(p.internalName);
        var emailText = self._getDynamicTextValue(p.emailText);
        var isSelected = !!self.selected[p.secId];

        html += '<div class="picker-item' + (isSelected ? ' selected' : '') +
          '" data-sec-id="' + p.secId + '">' +
          '<div class="picker-item-checkbox">' +
          '<svg class="check-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">' +
          '<path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 ' +
          '12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 ' +
          '393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>' +
          '</div>' +
          '<div class="picker-item-content">' +
          '<div class="picker-item-top">' +
          '<span class="picker-item-code">' + _.escape(p.code) + '</span>' +
          '<span class="picker-item-name">' + _.escape(name) + '</span>' +
          '</div>' +
          (emailText ? '<div class="picker-item-preview">' + _.escape(emailText).substring(0, 80) +
          (emailText.length > 80 ? '...' : '') + '</div>' : '') +
          '</div>' +
          '</div>';
      });

      if (phrases.length === 0) {
        html = '<div class="picker-empty">' + _.i18n('common.noResults') + '</div>';
      }

      this.ui.list.html(html);
    },

    onSearch: function () {
      var query = this.ui.searchInput.val().toLowerCase();
      var self = this;

      if (!query) {
        this._renderList(this.phrases);
        return;
      }

      var filtered = _.filter(this.phrases, function (p) {
        var name = self._getDynamicTextValue(p.internalName).toLowerCase();
        var code = (p.code || '').toLowerCase();
        var emailText = self._getDynamicTextValue(p.emailText).toLowerCase();
        return code.indexOf(query) !== -1 ||
          name.indexOf(query) !== -1 ||
          emailText.indexOf(query) !== -1;
      });

      this._renderList(filtered);
    },

    onToggleItem: function (e) {
      var $item = $(e.currentTarget);
      var secId = $item.data('sec-id');

      if (this.selected[secId]) {
        delete this.selected[secId];
        $item.removeClass('selected');
      } else {
        this.selected[secId] = true;
        $item.addClass('selected');
      }

      this._updateSelectionCount();
    },

    _updateSelectionCount: function () {
      var count = Object.keys(this.selected).length;
      this.ui.selectionCount.text(count + ' ' + _.i18n('common.selected'));
      this.ui.confirmBtn.prop('disabled', count === 0);
    },

    _closeWindow: function () {
      if (this.windows && this.windows.modalView) {
        this.windows.modalView.close();
      }
    },

    onConfirm: function () {
      var secIds = Object.keys(this.selected);
      this.trigger('phrases:selected', secIds);
      this._closeWindow();
    },

    onCancel: function () {
      this.trigger('phrases:cancelled');
      this._closeWindow();
    }
  });
});

